var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon55(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000096763373029937532660000015754666416864097187_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33 35.8",
    style: {
      enableBackground: "new 0 0 33 35.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.6,26.1c0.5-0.7,0.8-1.6,0.8-2.5c0-2.4-2-4.4-4.4-4.4s-4.4,2-4.4,4.4c0,0.9,0.3,1.8,0.8,2.5 c-1.9,0.6-3.2,2.3-3.2,4.4v0.8c0,0.6,0.5,1,1,1s1-0.4,1-1v-0.9c0-1.4,1.2-2.5,2.5-2.5h4.4c1.4,0,2.5,1.2,2.5,2.5v0.9 c0,0.6,0.5,1,1,1s1-0.4,1-1v-0.9C13.8,28.4,12.5,26.6,10.6,26.1L10.6,26.1z M7,25.9c-1.3,0-2.3-1-2.3-2.3s1-2.3,2.3-2.3 s2.3,1,2.3,2.3C9.3,24.8,8.3,25.9,7,25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.5,26.1c0.5-0.7,0.8-1.6,0.8-2.5c0-2.4-2-4.4-4.4-4.4s-4.4,2-4.4,4.4c0,0.9,0.3,1.8,0.8,2.5 c-1.9,0.6-3.2,2.3-3.2,4.4v0.8c0,0.6,0.5,1,1,1s1-0.4,1-1v-0.9c0-1.4,1.2-2.5,2.5-2.5H28c1.4,0,2.5,1.2,2.5,2.5v0.9 c0,0.6,0.5,1,1,1s1-0.4,1-1v-0.9C32.8,28.4,31.4,26.6,29.5,26.1L29.5,26.1z M23.7,23.6c0-1.3,1-2.3,2.3-2.3s2.3,1,2.3,2.3 s-1,2.3-2.3,2.3S23.7,24.8,23.7,23.6L23.7,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26,18c-0.6,0-1-0.4-1-1v-7c0-0.7-0.6-1.4-1.4-1.4h-0.2c-0.6,0-1-0.4-1-1s0.4-1,1-1h0.2C25.5,6.5,27,8,27,9.9 v7C27,17.6,26.5,18,26,18L26,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7,18c-0.6,0-1-0.4-1-1v-7c0-2,1.5-3.5,3.4-3.5h0.2c0.6,0,1,0.4,1,1s-0.4,1-1,1H9.4C8.7,8.5,8,9.1,8,9.9v7 C8.1,17.6,7.5,18,7,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,10.4c0.5-0.7,0.8-1.6,0.8-2.5c0-2.4-2-4.4-4.4-4.4S12,5.5,12,7.9c0,0.9,0.3,1.8,0.8,2.5 C11,11,9.6,12.7,9.6,14.8v0.8c0,0.6,0.5,1,1,1s1-0.4,1-1v-0.9c0-1.4,1.2-2.5,2.5-2.5h4.4c1.4,0,2.5,1.2,2.5,2.5v0.9 c0,0.6,0.5,1,1,1s1-0.4,1-1v-0.9C23.2,12.7,21.9,10.9,20,10.4L20,10.4z M16.4,10.2c-1.3,0-2.3-1-2.3-2.3s1-2.3,2.3-2.3 s2.3,1,2.3,2.3S17.7,10.2,16.4,10.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon55);
export default __webpack_public_path__ + "static/media/icon55.48b082b0b55e532a4523204f26809b4b.svg";
export { ForwardRef as ReactComponent };